// extracted by mini-css-extract-plugin
export default {"card":"Card_card__6M+2k","label":"Card_label__Bc2ap"};